import { render, staticRenderFns } from "./ConsigneeInformationForm.vue?vue&type=template&id=3345b23c"
import script from "./ConsigneeInformationForm.vue?vue&type=script&lang=js"
export * from "./ConsigneeInformationForm.vue?vue&type=script&lang=js"
import style0 from "./ConsigneeInformationForm.vue?vue&type=style&index=0&id=3345b23c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports